export default __webpack_public_path__ + "static/media/bf.24f70375.jpg";